import { render, staticRenderFns } from "./PendingContracts.vue?vue&type=template&id=573a8830&scoped=true"
import script from "./PendingContracts.vue?vue&type=script&lang=js"
export * from "./PendingContracts.vue?vue&type=script&lang=js"
import style0 from "./PendingContracts.vue?vue&type=style&index=0&id=573a8830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a8830",
  null
  
)

export default component.exports